import { useEffect } from "react";
import { useNavigate, Outlet } from "react-router-dom";

const ProtectedRoutes = () => {
  const navigate = useNavigate();
  const accessToken = localStorage.getItem('accessToken');

  useEffect(() => {
    if (!accessToken) {
      navigate('/');
    }
  }, [accessToken, navigate]);

  return <Outlet />;
};

export default ProtectedRoutes;